<template>
  <base-container ref="container" :isLoading="loading">
    <ArtisanGrid
      ref="message"
      metaKey="BedMessageRecord"
      :searchInited="searchInited"
      :handleQuery="handleQuery"
      @testMsg="testMsg"
    >
      <template #patientName="{ row }">
        <el-button type="text" @click="viewBedDetail(row)">{{
          row.patientName
        }}</el-button>
      </template>
    </ArtisanGrid>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      height="75%"
      width="75%"
      ref="drawer"
    >
      <el-row v-if="dialog.show" style="height: 100%">
        <el-col style="height: 100%; background-color: white" :span="8">
          <artisan-group style="height: 100%" title="入院卡信息">
            <RecordDetail :recordId="dialog.recordId"></RecordDetail>
          </artisan-group>
        </el-col>
        <el-col
          v-if="dialog.show"
          style="height: 100%; padding: 0 5px"
          :span="16"
        >
          <artisan-group style="height: 100%" title="轨迹节点">
            <RecordLog :recordId="dialog.recordId"></RecordLog>
          </artisan-group>
        </el-col>
      </el-row>
    </artisan-dialog>
  </base-container>
</template>
<script>
import moment from "moment";
import RecordDetail from "./RecordDetail.vue";
import RecordLog from "./RecordLog.vue";
import { testMsg } from "@/api/bed/reserve";
export default {
  components: { RecordDetail, RecordLog },
  data() {
    return {
      loading: false,
      dialog: {
        recordId: "",
        title: "",
        show: false,
      },
    };
  },
  methods: {
    searchInited(query) {
      const start = moment().subtract(7, "days").format("YYYY-MM-DD");
      const end = moment().format("YYYY-MM-DD");
      query.createTime = [start, end];
    },
    handleQuery(param) {
      if (param.createTime.length == 2) {
        param.createTime =
          param.createTime[0] +
          " 00:00:00," +
          param.createTime[1] +
          " 23:59:59";
      }
      return param;
    },
    viewBedDetail(row) {
      this.record = row;
      this.dialog.recordId = row.recordId;
      this.dialog.title = "预约详情--" + row.patientName;
      this.dialog.show = true;
    },
    testMsg(row) {
      this.$refs.container
        .prompt({ msg: "请输入患者的身份证号！" })
        .then((val) => {
          if (val) {
            testMsg(row.id,val).then(() => {
              this.$message({
                type: "success",
                message: "发送成功！",
              });
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
